import React, { FC, useContext } from 'react';
import { Accordion, AccordionContext, Card, Col, Form, Row } from 'react-bootstrap';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import { AnyType } from '../interfaces';
import { AppRootState } from '../redux';
import { dateFormatter } from '../utils';

export type BITabProps = {
  benefitInvestigations?: AnyType[] | AnyType;
  orgnizationId?: number;
};

export const BISection = (biProps: BITabProps) => {
  const biFields = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})['case-details.bi'] as AnyType)?.data?.fields || {}
  );

  type BIListType = { bIType: string; bICreatedDate: string; benefitInvestigations: AnyType[] };
  const bIList: AnyType[] = biProps?.benefitInvestigations || [];

  interface Props {
    children: React.ReactNode;
    eventKey: string;
  }

  const ContextAwareToggle: FC<Props> = (props: Props) => {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === props.eventKey;

    return (
      <Accordion.Button
        as={Card.Header}
        className='cmx__case-detail-main-section-summary-tab__card-header'
        eventKey={props.eventKey}>
        <div>{props.children}</div>
        <hr />
        {isCurrentEventKey && <ChevronUp />}
        {!isCurrentEventKey && <ChevronDown />}
      </Accordion.Button>
    );
  };

  const FieldHeaderCol = ({ fieldName }: { fieldName: string }) => (
    <Col className={biFields?.[fieldName]?.hideField ? 'd-none' : 'md-'}>
      <Form.Label className='detail__label text-secondary'>{fieldName}</Form.Label>
    </Col>
  );

  const FieldValueCol = ({ bi, fieldName, isDate }: { bi: AnyType; fieldName: string; isDate?: boolean }) => (
    <Col className={biFields?.[fieldName]?.hideField ? 'd-none' : ''}>
      <p className='detail__value'>{isDate ? dateFormatter(bi?.[fieldName]) : fieldName}</p>
    </Col>
  );

  const IndividualBISection = ({ bIType, bICreatedDate, benefitInvestigations }: BIListType) => (
    <Card className=''>
      <Card.Header className='text-secondary bg-white section__title'>
        <i className='fa-light fa-circle-arrow-up' style={{ color: '#0084A9' }}></i>
        {`Benefit Verification - ${bIType ? bIType : ''} - ${bICreatedDate ? dateFormatter(bICreatedDate) : ''}`}
      </Card.Header>
      <Card.Body className='cmx__case-detail-main-section-summary-tab__card-body'>
        <Row>
          <FieldHeaderCol fieldName='Plan Name:' />
          <FieldHeaderCol fieldName='Plan Type:' />
          <FieldHeaderCol fieldName='BI Type:' />
          <FieldHeaderCol fieldName='Product Covered:' />
          <FieldHeaderCol fieldName='Prior Auth. Required:' />
          <FieldHeaderCol fieldName='Therapy/Drug:' />
        </Row>
        {benefitInvestigations && benefitInvestigations?.length > 0 ? (
          benefitInvestigations?.map((bi: AnyType, index: number) => (
            <Row key={'bi-tab-collapsable-sec-data-first-row-' + index}>
              <FieldValueCol bi={bi} fieldName='insurancePlanName' />
              <FieldValueCol bi={bi} fieldName='insurancePlanType' />
              <FieldValueCol bi={bi} fieldName='bIType' />
              <FieldValueCol bi={bi} fieldName='productCovered' />
              <FieldValueCol bi={bi} fieldName='priorAuthRequired' />
              <FieldValueCol bi={bi} fieldName='therapyOrDrug' />
            </Row>
          ))
        ) : (
          <Row key={'bi-tab-collapsable-sec-data-first-row-'}>
            <FieldValueCol bi={''} fieldName='---' />
            <FieldValueCol bi={''} fieldName='---' />
            <FieldValueCol bi={''} fieldName='---' />
            <FieldValueCol bi={''} fieldName='---' />
            <FieldValueCol bi={''} fieldName='---' />
            <FieldValueCol bi={''} fieldName='---' />
          </Row>
        )}
        <br />
        <br />
      </Card.Body>
    </Card>
  );

  return (
    <div>
      {bIList.length > 0 ? (
        bIList.map((bi: AnyType, index: number) => (
          <IndividualBISection
            key={bi?.bIType + index}
            bIType={bi?.bIType}
            bICreatedDate={bi.bICreatedDate}
            benefitInvestigations={[bi]}
          />
        ))
      ) : (
        <IndividualBISection bIType='' bICreatedDate='' benefitInvestigations={[]} />
      )}
    </div>
  );
};
